module.exports = __webpack_public_path__ + "img/mapway3.7b9e2e82.jpg";